import type { FinanceDashboardResponse } from '@yawi/types';
import type { IFinanceDashboardRepository } from '@yawi/domain';
import { getApiClient } from '../../http/apiClient';

export class ApiFinanceDashboardRepository implements IFinanceDashboardRepository {
  async getDashboard(month?: string): Promise<FinanceDashboardResponse> {
    const client = getApiClient();
    const query = month ? `?month=${month}` : '';
    return client.get<FinanceDashboardResponse>(`v1/finance/dashboard${query}`);
  }
}
